export default __webpack_public_path__ + "static/media/de.ae6d96ef.svg";